import Filter from './FilterContainer';

export default Filter;
